import {StyleSheet as PDFStyleSheet, Font} from '@react-pdf/renderer';
import PlatformService from 'src/services/PlatformService';

export const getResumeFont = () => (PlatformService.isNativeApp() ? 'Helvetica' : 'Open Sans');

export const registerWebFonts = () => {
  if (!PlatformService.isNativeApp()) {
    Font.register({
      family: 'Open Sans',
      fonts: [
        {src: '/fonts/OpenSans400.ttf', fontStyle: 'normal', fontWeight: 'normal'},
        {src: '/fonts/OpenSans700.ttf', fontStyle: 'normal', fontWeight: 'bold'},
        {src: '/fonts/OpenSans300.ttf', fontStyle: 'normal', fontWeight: 'light'},
      ],
    });
  }
};

export const createPlainResumeHeaderStyles = () =>
  PDFStyleSheet.create({
    infoContainer: {},
    headerContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      marginTop: 24,
    },
    nameText: {
      fontSize: 36,
    },
    contactText: {
      fontSize: 12,
      marginTop: 4,
    },
    infoText: {
      fontWeight: 'normal',
      fontSize: 12,
      marginTop: 8,
    },
  });

export const createHeaderStyles = () =>
  PDFStyleSheet.create({
    infoContainer: {},
    headerContainer: {
      fontFamily: getResumeFont(),
      fontWeight: 'bold',
      position: 'absolute',
      top: 0,
      left: 24,
      flexDirection: 'row',
      alignItems: 'center',
      height: 140,
    },
    headerImage: {
      height: 140,
      width: '100%',
      objectFit: 'cover',
    },
    nameText: {
      fontSize: 36,
      color: '#ffffff',
    },
    infoText: {
      marginTop: 4,
      fontWeight: 'normal',
      fontSize: 12,
      color: '#ffffff',
    },
    pill: {
      fontWeight: 'normal',
      fontSize: 10,
      paddingTop: 2,
      paddingLeft: 8,
      paddingRight: 8,
      paddingBottom: 2,
      marginRight: 8,
      borderRadius: 10,
      backgroundColor: '#ffffff',
      color: '#366aff',
    },
    pillContainer: {
      marginTop: 8,
      flexDirection: 'row',
    },
  });

export const createResumePageStyles = () =>
  PDFStyleSheet.create({
    pageContainer: {
      width: '100%',
      paddingLeft: 24,
      paddingRight: 24,
      fontFamily: getResumeFont(),
      fontWeight: 'bold',
    },
  });
